import { IonButton } from '@ionic/react'
import React from 'react'

import {
	useShowTeamSelectionState,
} from './data'

const NoTeamSelected = () => {
	const [ showTeamSelection, setShowTeamSelection ] = useShowTeamSelectionState()

	return (
		<div className="no-items">
			<p>
				No team selected.
			</p>
			<p>
				<IonButton
					onClick={() => setShowTeamSelection(!showTeamSelection)}
				>
					Select team
				</IonButton>
			</p>
		</div>
	)
}

export default NoTeamSelected
